// @ts-nocheck
import { Grid } from '@material-ui/core';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { ENERGY_CARD_BORDER, ENERGY_TEXT_PRIMARY, ENERGY_TEXT_SECONDARY } from './EnergyOverviewCard.jsx';

const CONSUMED_COLOR = '#d5d9df';
const AVOIDED_BORDER_COLOR = '#9aa1ab';

function formatNumber(value, fractionDigits = 0) {
  return Number(value || 0).toLocaleString(undefined, { maximumFractionDigits: fractionDigits });
}

function formatCurrency(value, currency) {
  try {
    return Number(value || 0).toLocaleString(undefined, { style: 'currency', currency: currency || 'EUR', maximumFractionDigits: 0 });
  } catch (error) {
    return `${formatNumber(value)} ${currency || ''}`;
  }
}

const innerBoxStyle = {
  border: `1px solid ${ENERGY_CARD_BORDER}`,
  borderRadius: 4,
  padding: 14,
  height: '100%',
  boxSizing: 'border-box',
};

const EnergyAvoidedSection = ({ energySummary }) => {
  const { avoidedKwhYearToDate, avoidedCostYearToDate, currency, months } = energySummary;
  const data = {
    labels: _.map(months, month => moment(month.month, 'YYYY-MM').format('MMM')),
    datasets: [
      {
        label: L20NContext.getSync('energyOverviewConsumed'),
        data: _.map(months, month => Number(month.consumedKwh) || 0),
        backgroundColor: CONSUMED_COLOR,
        borderColor: CONSUMED_COLOR,
        borderWidth: 1,
      },
      {
        label: L20NContext.getSync('energyOverviewAvoided'),
        data: _.map(months, month => Number(month.avoidedKwh) || 0),
        backgroundColor: 'white',
        borderColor: AVOIDED_BORDER_COLOR,
        borderWidth: 1,
      },
    ],
  };
  const options = {
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: 'top',
      align: 'end',
      labels: { boxWidth: 10, fontSize: 10, fontColor: ENERGY_TEXT_SECONDARY },
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, chartData) => `${chartData.datasets[tooltipItem.datasetIndex].label}: ${formatNumber(tooltipItem.yLabel)} kWh`,
      },
    },
    scales: {
      xAxes: [{
        gridLines: { display: false },
        ticks: { fontColor: ENERGY_TEXT_SECONDARY, fontSize: 10 },
      }],
      yAxes: [{
        display: false,
        ticks: { beginAtZero: true },
      }],
    },
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <div style={{ ...innerBoxStyle, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
          <span style={{ fontSize: 30, fontWeight: 'bold', color: ENERGY_TEXT_PRIMARY }}>{formatNumber(avoidedKwhYearToDate)}</span>
          <h6 style={{ margin: 0, marginTop: 4, fontSize: 12, color: ENERGY_TEXT_SECONDARY }}><Entity entity="energyOverviewKwhAvoidedYtd" /></h6>
          {avoidedCostYearToDate !== null && avoidedCostYearToDate !== undefined ? (
            <span style={{ marginTop: 10, fontSize: 16, fontWeight: 'bold', color: ENERGY_TEXT_PRIMARY }}>
              ≈ {formatCurrency(avoidedCostYearToDate, currency)}
            </span>
          ) : null}
        </div>
      </Grid>
      <Grid item xs={12} md={9}>
        <div style={innerBoxStyle}>
          <h5 style={{ margin: 0, fontWeight: 'bold', fontSize: 13, color: ENERGY_TEXT_PRIMARY }}><Entity entity="energyOverviewConsumedVsAvoided" /></h5>
          <div style={{ height: 140, position: 'relative' }}>
            <Bar data={data} options={options} />
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default EnergyAvoidedSection;
